import React, { useState } from "react";
import { List } from "@mui/material";
import SidebarSection from "./SidebarSection";
import { getMenuItems } from "./MenuItems";
import useAuth from "../../context";

const SidebarMenu = ({ open }) => {
    const [openSection, setOpenSection] = useState(null);
    const auth = useAuth();
    const menuItems = getMenuItems(auth);

    const handleSectionToggle = (section) => {
        setOpenSection(openSection === section ? null : section);
    };

    return (
        <List>
            <SidebarSection
                open={open}
                title="Research"
                items={menuItems.find((item) => item.name === "Research").items}
                isOpen={openSection === "research"}
                onToggle={() => handleSectionToggle("research")}
            />

            <SidebarSection
                open={open}
                title="Create"
                items={menuItems.find((item) => item.name === "Create").items}
                isOpen={openSection === "create"}
                onToggle={() => handleSectionToggle("create")}
            />
            <SidebarSection
                open={open}
                title="Measure"
                items={menuItems.find((item) => item.name === "Measure").items}
                isOpen={openSection === "measure"}
                onToggle={() => handleSectionToggle("measure")}
            />
            <SidebarSection
                open={open}
                title="Monetize"
                items={menuItems.find((item) => item.name === "Monetize").items}
                isOpen={openSection === "monetize"}
                onToggle={() => handleSectionToggle("monetize")}
            />
            <SidebarSection
                open={open}
                title="Platforms"
                items={menuItems.find((item) => item.name === "Platforms").items}
                isOpen={openSection === "platforms"}
                onToggle={() => handleSectionToggle("platforms")}
            />
            <SidebarSection
                open={open}
                title="Support"
                items={menuItems.find((item) => item.name === "Support").items}
                isOpen={openSection === "support"}
                onToggle={() => handleSectionToggle("support")}
            />
            {(auth.user.role === "ADMIN" ||
                auth.user.role === "EXECUTIVE_ADMIN") && (
                <SidebarSection
                    open={open}
                    title="Admin Dashboard"
                    items={
                        menuItems.find(
                            (item) => item.name === "Admin Dashboard"
                        ).items
                    }
                    isOpen={openSection === "admin"}
                    onToggle={() => handleSectionToggle("admin")}
                />
            )}
        </List>
    );
};

export default SidebarMenu;
